import { fontSize, minBreakpoints, primarySemiBoldFont, theme } from '@noths/polaris-client-ribbons-base';
import { inset, mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
var spacing = theme.spacing,
  text = theme.text;
export var footerSections = /*#__PURE__*/css(["padding:", ";", ";"], inset(spacing.md, 0), mediaQuery({
  min: minBreakpoints.L
}, css(["padding:", ";"], inset(spacing.xl, 0))));
export var firstSection = /*#__PURE__*/css(["background-color:var(--tertiary-coral-10);"]);
export var secondSection = /*#__PURE__*/css(["background-color:var(--neutral-black-10);"]);
export var thirdSection = /*#__PURE__*/css(["background-color:var(--neutral-black-base);"]);
export var footerInner = /*#__PURE__*/css(["max-width:", ";margin:0 auto;"], pxToRem(minBreakpoints.XL));
export var appSection = /*#__PURE__*/css(["display:flex;justify-content:space-around;text-align:center;flex-direction:column;", ";"], mediaQuery({
  min: minBreakpoints.M
}, css(["padding:0 ", ";flex-direction:row;"], pxToRem(spacing.xl))));
export var paymentSection = /*#__PURE__*/css(["display:flex;flex-direction:column;justify-content:space-between;align-items:center;", ";"], mediaQuery({
  min: minBreakpoints.M
}, css(["padding:0;flex-direction:row;"])));
export var localePanel = /*#__PURE__*/css(["width:100%;padding:", ";border-bottom:1px solid var(--neutral-black-30);", ";"], inset(0, spacing.xxl), mediaQuery({
  min: minBreakpoints.M
}, css(["width:", ";border-bottom:0 none;"], pxToRem(260))));
export var localePanelHeading = /*#__PURE__*/css(["", " ", ""], fontSize(text.HEADING.XS), primarySemiBoldFont);
export var localePanelFlag = /*#__PURE__*/css(["margin-left:auto;", ";"], mediaQuery({
  min: minBreakpoints.M
}, css(["margin-left:", ";"], pxToRem(spacing.xs))));
export var localePanelButton = /*#__PURE__*/css(["margin-left:", ";", ";"], pxToRem(spacing.md), mediaQuery({
  min: minBreakpoints.M
}, css(["margin-left:auto;"])));